import { useEffect, useState } from "react";

const CHAVE = "privacidade-ok";

export function MobilePrivacyConsent() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CHAVE)) setVisivel(true);
  }, []);

  if (!visivel) return null;

  return (
    <div data-testid="privacy-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[999] bg-black/40 backdrop-blur-sm px-4 pt-3 pb-6">
      <p className="text-[11px] leading-snug text-white/90 text-center">
        Utilizamos cookies para garantir a melhor experiência em nosso site. Os cookies nos permitem fornecer
        funcionalidades como segurança, gerenciamento de rede e acessibilidade. Eles melhoram a usabilidade e o
        desempenho por meio de vários recursos, como reconhecimento de idioma e resultados de pesquisa. Ao clicar
        nos botões, você pode aceitar todos os cookies ou, se quiser saber mais sobre os cookies que usamos e como
        gerenciá-los,{" "}
        <a href="https://app.braveaccess.com.br/politica-privacidade.html" target="_blank" rel="noreferrer"
          className="underline text-sky-300" data-testid="privacy-consent-link">
          acesse nossa Política de Privacidade
        </a>.
      </p>
      <button type="button" data-testid="privacy-consent-accept"
        onClick={() => { localStorage.setItem(CHAVE, "1"); setVisivel(false); }}
        className="mt-2 w-full rounded-full bg-sky-500 py-2 text-sm font-semibold text-white active:scale-95 transition-transform">
        Concordo
      </button>
    </div>
  );
}
